import Vue from "vue";

export default Vue.component("RenderTemplate", {
  props: {
    string: {
      required: true,
      type: String
    }
  },
  render(h) {
    const render = {
      template: `<div>${this.string}</div>`,
    }
    return h(render)
  }
});